import { Directive, Input } from '@angular/core';

let nextUniqueId = 0;
@Directive({
	selector: 'bll-error',
	host: {
		class: 'bll-error',
		role: 'alert',
		'[attr.id]': 'id',
	},
})
export class BllError {
	@Input() id: string = `bll-error-${nextUniqueId++}`;
}
